import { forwardRef } from 'react';
import {
    useTheme,
    experimentalStyled as styled,
  } from '@material-ui/core/styles'
import { Stack, Grid, Box, Typography } from '@material-ui/core';
import { FacilityTypes, UNITS } from 'src/constants/Defaultvalues';
import useCompanyProfile from 'src/hooks/useCompanyProfile';
import moment from 'moment';
import { formatDateOnly } from 'src/utils/dateOnly';
import { empty } from 'src/Helpers/Common';
import { fUSPrice } from 'src/utils/formatNumber';

const PurchaseOrderInvoicePage = forwardRef(({ invoiceDate, details, invoice, orderServices = [], data, hasViewCostPermission=true }, ref) => {
    const canViewCosts = !!hasViewCostPermission;
    /** Service-type products (material_types 3 = Services) or meterial 2: no line-level service name/cost on PO. */
    const showLineItemServiceColumns = (val) =>
        Number(val?.meterial) !== 2 && Number(val?.material_types) !== 3;
    const cellWrapTight = {
        minWidth: 0,
        boxSizing: 'border-box',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'anywhere',
    };
    const formattedNotes = Array.isArray(details?.notes) && details?.notes?.length
        ? details?.notes?.join('\n')
        : (typeof details?.notes === 'string' ? details?.notes : '');
    const theme = useTheme();
    const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
    let customerProductTotal = 0;
    return (
        <>
            <Box
                component="style"
                dangerouslySetInnerHTML={{
                    __html: `
                      @media print {
                        html, body, #root {
                          background: #ffffff !important;
                        }
                      }
                    `
                }}
            />
            <Stack ref={ref} style={{ background: '#ffffff', color: '#000000' }}>
            <Grid container spacing={1} sx={{ position: 'relative', display: 'flex', justifyContent: 'space-between' }}>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                        <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 510, paddingRight: '6px' }}>
                            {/* <Box component="img" alt="logo" src={COMPANY_LOGO} id="logoImage" sx={{ height: 98, alignSelf: 'flex-start', filter: 'grayscale(100%)' }} /> */}
                            {/* <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ alignSelf: 'flex-start', filter: 'grayscale(100%)', width: "250px" }} /> */}
                            <Stack direction="column" sx={{ mt: 1, color: 'black' }}>
                                <Typography variant="h4" sx={{ fontWeight: 700 }}>{COMPANY_NAME}</Typography>
                                {/* <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>{data?.company_website}</Typography> */}
                                <Typography variant="body1">{data?.address}</Typography>
                                <Typography variant="body1">{data?.city}, {data?.state} {data?.zipcode}</Typography>
                                <Typography variant="body2">{(data?.phone_country_code || data?.phone) ? `Phone # ${data?.phone_country_code ? `+${data?.phone_country_code} ` : ''}${data?.phone}` : 'Phone # 951-682-9660'}</Typography>
                                <Typography variant="body2">{data?.company_fax_number ? `Fax # ${data?.company_fax_number}` : ''}</Typography>
                                {/* <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
                                    <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>|</Typography>
                                </Box> */}
                                {/* <Typography variant="h6" sx={{ textTransform: 'uppercase' }}>{data?.company_mail}</Typography> */}
                            </Stack>
                        </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 516 }}>
                        <Typography
                            variant="h2"
                            sx={{
                                textTransform: 'uppercase',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                color: 'black',
                                mb: 0.5,
                                fontSize: '3rem',
                                letterSpacing: '0.5px'
                            }}
                        >
                            Purchase Order
                        </Typography>
                        <Box
                            component="style"
                            dangerouslySetInnerHTML={{
                                __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                            }}
                        />
                        <table
                            className="sales-order-table"
                            style={{
                                width: '58%',
                                marginLeft: 'auto',
                                border: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                tableLayout: 'fixed'
                            }}
                        >
                            <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Date
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                         P.O. No.
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {invoiceDate}
                                    </td>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        #{details?.doc_number || details?.order_id || ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {/* <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                borderBottom: '1px solid black',
                                borderLeft: '1px solid black',
                                borderRight: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                marginTop: 0,
                                tableLayout: 'fixed'
                            }}
                        >
                            <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        PO #
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        PRIMARY SALES REP
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        &nbsp;
                                    </td>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        &nbsp;
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                borderBottom: '1px solid black',
                                borderLeft: '1px solid black',
                                borderTop: '1px solid black',
                                borderRight: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                marginTop: 0,
                                marginBottom: '10px',
                                tableLayout: 'fixed'
                            }}
                        >
                            <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            borderBottom: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        PAYMENT TERMS
                                    </th>
                                    <th
                                        style={{
                                            borderBottom: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            backgroundColor: '#ffffff',
                                            padding: '8px',
                                            textAlign: 'center',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        &nbsp;
                                    </th>
                                </tr>
                            </thead>
                        </table> */}
                    </Box>
                </Grid>
            </Grid>

            <Grid container spacing={1} sx={{ position: 'relative', display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 510, paddingRight: '6px', minHeight: 190 }}>
                        <Box
                            component="style"
                            dangerouslySetInnerHTML={{
                                __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                            }}
                        />
                        <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                border: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                minHeight: 190,
                            }}
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'left',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Vendor
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'left',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            verticalAlign: 'top',
                                        }}
                                    >
                                        {details?.vendor_name || invoice?.customer_name || ''}
                                        <br />
                                        {details?.vendor_address || (details?.remit_to_address || details?.remit_to_city || details?.remit_to_zip_code ? [details?.remit_to_address, details?.remit_to_city, details?.remit_to_zip_code].filter(Boolean).join(', ') : null) || (details?.address || details?.city || details?.zip_code ? [details?.address, details?.city, details?.zip_code].filter(Boolean).join(', ') : null) || invoice?.customer_address || ''} <br/><br />
                                        Phone # {details?.vendor_phone || ''}
                                        <br />
                                        Fax # {details?.vendor_fax || ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 516, minHeight: 190 }}>
                        <Box
                            component="style"
                            dangerouslySetInnerHTML={{
                                __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                            }}
                        />
                        
                        <>
                        {/* PROJECT CONTACT NAME AND PHONE NUMBER */}
                        {/* <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                borderBottom: '1px solid black',
                                borderLeft: '1px solid black',
                                borderRight: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                marginTop: 0,
                                tableLayout: 'fixed'
                            }}
                        >
                            <colgroup>
                                <col style={{ width: '50%' }} />
                                <col style={{ width: '50%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        VENDOR CONTACT NAME
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        VENDOR PHONE NUMBER
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        &nbsp;
                                    </td>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        {details?.vendor_phone || ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                        </>
                        

                        {/* PROJECT INSTALL ADDRESS */}
                        <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                borderLeft: '1px solid black',
                                borderRight: '1px solid black',
                                borderBottom: '1px solid black',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                marginTop: 0,
                                minHeight: 190
                            }}
                        >
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'left',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Ship To
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'left',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            verticalAlign: 'top',
                                        }}
                                    >
                                        {COMPANY_NAME}
                                        <br />
                                        {data?.address}
                                        <br />
                                        {data?.city}, {data?.state}, {data?.zipcode}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Box>
                </Grid>
            </Grid>

            <Grid container sx={{ display: 'flex', flexDirection: 'column', mt: 2 }}>
                <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                    <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                        {/* PROJECT CONTACT NAME AND PHONE NUMBER */}
                        <table
                            className="sales-order-table"
                            style={{
                                width: '100%',
                                border: 'none',
                                borderCollapse: 'collapse',
                                textTransform: 'uppercase',
                                tableLayout: 'fixed'
                            }}
                        >
                            <colgroup>
                                <col style={{ width: '19%' }} />
                                <col style={{ width: '23%' }} />
                                <col style={{ width: '15%' }} />
                                <col style={{ width: '12.5%' }} />
                                <col style={{ width: '12.5%' }} />
                                <col style={{ width: '18%' }} />
                            </colgroup>
                            <thead>
                                <tr>
                                <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Order Placed With
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Project / Sales Order #
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Terms
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Date Req'd
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Date Promised
                                    </th>
                                    <th
                                        style={{
                                            border: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: '#e6e6e6',
                                            fontWeight: 'bold',
                                            color: 'black',
                                            textTransform: 'uppercase'
                                        }}
                                    >
                                        Ship Via
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td
                                    style={{
                                        borderTop: '1px solid black',
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        padding: '8px',
                                        textAlign: 'center',
                                        backgroundColor: 'white',
                                        color: 'black',
                                        textTransform: 'uppercase',
                                        lineHeight: '18px',
                                        ...cellWrapTight,
                                    }}
                                >
                                    {details?.sales_order_doc_number || ''}
                                </td>
                                    <td
                                        style={{
                                            borderTop: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'pre-line',
                                            lineHeight: '18px',
                                            ...cellWrapTight,
                                        }}
                                    >
                                        {details?.sales_order_name || ''}
                                    </td>
                                    <td
                                        style={{
                                            borderTop: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere',
                                            lineHeight: '18px'
                                        }}
                                    >
                                        {details?.customer_billing_type && details?.customer_billing_type_value != null
                                            ? `${details.customer_billing_type} ( ${details.customer_billing_type_value} % )`
                                            : ''}
                                    </td>
                                    <td
                                        style={{
                                            borderTop: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'normal',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere',
                                            lineHeight: '18px'
                                        }}
                                    >
                                        {(details?.sales_order_participation_ends || details?.sales_order_installation_end_date)
                                            ? formatDateOnly(details?.sales_order_participation_ends || details?.sales_order_installation_end_date)
                                            : ''}
                                    </td>
                                    <td
                                        style={{
                                            borderTop: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'normal',
                                            fontSize: '14px',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere',
                                            lineHeight: '18px'
                                        }}
                                    >
                                        {moment(details?.expected_date * 1000).format('MM/DD/YYYY') || ''}
                                    </td>
                                    <td
                                        style={{
                                            borderTop: '1px solid black',
                                            borderLeft: '1px solid black',
                                            borderRight: '1px solid black',
                                            padding: '8px',
                                            textAlign: 'center',
                                            backgroundColor: 'white',
                                            color: 'black',
                                            textTransform: 'uppercase',
                                            whiteSpace: 'normal',
                                            fontSize: '14px',
                                            wordBreak: 'break-word',
                                            overflowWrap: 'anywhere',
                                            lineHeight: '18px'
                                        }}
                                    >
                                        {details?.ship_via || ''}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </Box>
                </Grid>
                    <>
                        {invoice?.filter(item => item.meterial == 0).length > 0 ? <>
                            <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                                    <Box
                                        component="style"
                                        dangerouslySetInnerHTML={{
                                            __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                                        }}
                                    />
                                    {/* PROJECT CONTACT NAME AND PHONE NUMBER */}
                                    <table
                                        className="sales-order-table"
                                        style={{
                                            width: '100%',
                                            border: '1px solid black',
                                            borderCollapse: 'collapse',
                                            textTransform: 'uppercase',
                                            tableLayout: 'fixed'
                                        }}
                                    >
                                        <colgroup>
                                            {/* OLD CATALOG COLGROUP WIDTHS - kept for backup */}
                                            {/* <col style={{ width: '12%' }} /> */}
                                            {/* <col style={{ width: '12%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */} {/* SKU */}
                                            {/* {canViewCosts && <col style={{ width: '11%' }} />} */}  {/* UNIT COST */}
                                            {/* <col style={{ width: '11%' }} /> */}  {/* QTY */}
                                            {/* <col style={{ width: '11%' }} /> */} {/* UNIT PRICE */}
                                            {/* <col style={{ width: canViewCosts ? '10%' : '14%' }} /> */}
                                            {/* {canViewCosts && <><col style={{ width: '10%' }} /><col style={{ width: '11%' }} /></>} */} {/* SERVICE NAME / SERVICE COST / AMOUNT */}
                                            {/* OLD CATALOG COLGROUP WIDTHS (uniform 11%) - kept for backup */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* {canViewCosts && <col style={{ width: '11%' }} />} */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: canViewCosts ? '11%' : '14%' }} /> */}
                                            {/* {canViewCosts && <><col style={{ width: '11%' }} /><col style={{ width: '11%' }} /></>} */}
                                            {/* NEW CATALOG COLGROUP WIDTHS - DESCRIPTION widened to avoid text touching the border; first 6 cols still sum to 66% to keep TOTAL row aligned with SERVICE NAME boundary */}
                                            <col style={{ width: '9%' }} />
                                            <col style={{ width: '17%' }} />
                                            <col style={{ width: '10%' }} /> {/* SKU */}
                                            {canViewCosts && <col style={{ width: '10%' }} />}  {/* UNIT COST */}
                                            <col style={{ width: '10%' }} />  {/* QTY */}
                                            <col style={{ width: '10%' }} /> {/* UNIT PRICE */}
                                            <col style={{ width: canViewCosts ? '11%' : '14%' }} />
                                            {canViewCosts && <><col style={{ width: '11%' }} /><col style={{ width: '11%' }} /></>} {/* SERVICE NAME / SERVICE COST / AMOUNT */}
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Item</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Description</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Qty Ordered</th>
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Unit Cost</th>}
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Qty Rec'd</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Delivered</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Service Name</th>
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Service Cost</th>}
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Amount</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {invoice?.filter(item => item.meterial == 0).map((val,index) => {
                      const { id, name, unit_cost,description, actual_qty, actual_total_cost,shipping_cost,service_cost, service_name} = val
                      const showLineSvc = showLineItemServiceColumns(val);
                      return (
                                                    <>
                                                        <tr key={id}>
                                                            <td
                                                                style={{
                                                                    border: '1px solid black',
                                                                    padding: '8px',
                                                                    textAlign: 'center',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    textTransform: 'uppercase',
                                                                    ...cellWrapTight,
                                                                }}
                                                            >
                                                                {name}
                                                            </td>
                                                            <td
                                                                style={{
                                                                    border: '1px solid black',
                                                                    padding: '8px',
                                                                    textAlign: 'left',
                                                                    backgroundColor: 'white',
                                                                    color: 'black',
                                                                    textTransform: 'uppercase',
                                                                    ...cellWrapTight,
                                                                }}
                                                            >
                                                                {description}
                                                            </td>
                                                            <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase',
                                                                whiteSpace: 'normal',
                                                                wordBreak: 'break-all',
                                                                overflowWrap: 'break-word',
                                                                hyphens: 'auto',
                                                                lineHeight: '18px'
                                                            }}>{actual_qty}</td>
                                                            {/* <TableCell align="center">{material === 1 ? '1' : quantity}({shortUnitName})</TableCell> */}
                                                            {canViewCosts && <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase'
                                                            }}>{`$${unit_cost.toFixed(2)}`}</td>}
                                                            <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase'
                                                            }}>
                                                                {actual_qty}
                                                            </td>
                                                            <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase'
                                                            }}>&nbsp;</td>
                                                            <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase',
                                                                lineHeight: '18px',
                                                                ...cellWrapTight,
                                                            }}>{showLineSvc ? (service_name || '') : ''}</td>
                                                            {canViewCosts && <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase'
                                                            }}>{showLineSvc ? `$${parseFloat(service_cost || 0).toFixed(2)}` : ''}</td>}
                                                            {canViewCosts && <td style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase'
                                                            }}>{`$${actual_total_cost.toFixed(2)}`}</td>}
                                                        </tr>
                                                    </>
                                                )
                                            }
                                            )}
                                        </tbody>
                                    </table>
                                </Box>
                            </Grid>
                        </> : null}

                        {invoice?.filter(item => item.meterial == 0).length === 0 && invoice?.filter(item => item.meterial == 1).length === 0 && (!orderServices || orderServices.length === 0) && (
                            <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                                    <table
                                        className="sales-order-table"
                                        style={{
                                            width: '100%',
                                            border: '1px solid black',
                                            borderCollapse: 'collapse',
                                            textTransform: 'uppercase',
                                            tableLayout: 'fixed'
                                        }}
                                    >
                                        <colgroup>
                                            <col style={{ width: '11%' }} />
                                            <col style={{ width: '20%' }} />
                                            <col style={{ width: '11%' }} />
                                            {canViewCosts && <col style={{ width: '11%' }} />}
                                            <col style={{ width: '11%' }} />
                                            <col style={{ width: '11%' }} />
                                            <col style={{ width: canViewCosts ? '9%' : '14%' }} />
                                            {canViewCosts && <><col style={{ width: '9%' }} /><col style={{ width: '10%' }} /></>}
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Item</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Description</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Qty Ordered</th>
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Unit Cost</th>}
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Qty Rec'd</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Delivered</th>
                                                <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Service Name</th>
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Service Cost</th>}
                                                {canViewCosts && <th style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', textTransform: 'uppercase' }}>Amount</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                {canViewCosts && <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>}
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td>
                                                {canViewCosts && <><td style={{ border: '1px solid black', height: '16px', backgroundColor: '#d3d3d3' }}>&nbsp;</td><td style={{ border: '1px solid black', height: '16px', backgroundColor: '#e9e9e9' }}>&nbsp;</td></>}
                                            </tr>
                                            <tr>
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                {canViewCosts && <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>}
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td>
                                                {canViewCosts && <><td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td><td style={{ border: '1px solid black', height: '40px', backgroundColor: '#efefef' }}>&nbsp;</td></>}
                                            </tr>
                                        </tbody>
                                    </table>
                                </Box>
                            </Grid>
                        )}

                        {invoice?.filter(item => item.meterial == 1).length > 0 && (
                            <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                                    <Box
                                        component="style"
                                        dangerouslySetInnerHTML={{
                                            __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                                        }}
                                    />
                                    <table
                                        className="sales-order-table"
                                        style={{
                                            width: '100%',
                                            border: '1px solid black',
                                            borderCollapse: 'collapse',
                                            textTransform: 'uppercase',
                                            tableLayout: 'fixed'
                                        }}
                                    >
                                        <colgroup>
                                            {/* OLD MATERIAL COLGROUP WIDTHS - kept for backup */}
                                            {/* <col style={{ width: '12%' }} /> */}
                                            {/* <col style={{ width: '12%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* {canViewCosts && <col style={{ width: '11%' }} />} */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: canViewCosts ? '10%' : '14%' }} /> */}
                                            {/* {canViewCosts && <><col style={{ width: '10%' }} /><col style={{ width: '11%' }} /></>} */}
                                            {/* OLD MATERIAL COLGROUP WIDTHS (uniform 11%) - kept for backup */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* {canViewCosts && <col style={{ width: '11%' }} />} */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: '11%' }} /> */}
                                            {/* <col style={{ width: canViewCosts ? '11%' : '14%' }} /> */}
                                            {/* {canViewCosts && <><col style={{ width: '11%' }} /><col style={{ width: '11%' }} /></>} */}
                                            {/* NEW MATERIAL COLGROUP WIDTHS - DESCRIPTION widened to avoid text touching the border; first 6 cols still sum to 66% to keep TOTAL row aligned with SERVICE NAME boundary */}
                                            <col style={{ width: '9%' }} />
                                            <col style={{ width: '17%' }} />
                                            <col style={{ width: '10%' }} />
                                            {canViewCosts && <col style={{ width: '10%' }} />}
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: '10%' }} />
                                            <col style={{ width: canViewCosts ? '11%' : '14%' }} />
                                            {canViewCosts && <><col style={{ width: '11%' }} /><col style={{ width: '11%' }} /></>}
                                        </colgroup>
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Item
                                                </th>
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Description
                                                </th>
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Qty Ordered
                                                </th>
                                                {canViewCosts && <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Unit Cost
                                                </th>}
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Qty Rec'd
                                                </th>
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Delivered
                                                </th>
                                                <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Service Name
                                                </th>
                                                {canViewCosts && <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Service Cost
                                                </th>}
                                                {canViewCosts && <th
                                                    style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Amount
                                                </th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {invoice?.filter(item => item.meterial == 1).map((val, index) => {
                                                const { id, name, unit_cost, description, actual_qty,actual_unit_qty, actual_total_cost, service_cost, service_name, convertion_qty,convertion_unit } = val;
                                                const showLineSvc = showLineItemServiceColumns(val);
                                                 const total_qty = actual_unit_qty * convertion_qty;
                                      const unitName = convertion_unit? UNITS.find(item => item.id == convertion_unit)?.name:'Unit';
                                      const quantity = convertion_unit==4 ?`${actual_unit_qty || 0} ${unitName}` : `${actual_unit_qty || 0}(${total_qty} ${unitName})`;
                                      
                                                return (
                                                    <tr key={`print-material-${id}`}>
                                                        <td
                                                            style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'center',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase',
                                                                ...cellWrapTight,
                                                            }}
                                                        >
                                                            {name}
                                                        </td>
                                                        <td
                                                            style={{
                                                                border: '1px solid black',
                                                                padding: '8px',
                                                                textAlign: 'left',
                                                                backgroundColor: 'white',
                                                                color: 'black',
                                                                textTransform: 'uppercase',
                                                                ...cellWrapTight,
                                                            }}
                                                        >
                                                            {description}
                                                        </td>
                                                        <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase',
                                                            whiteSpace: 'normal', 
                                                            wordBreak: 'break-all',
                                                            overflowWrap: 'break-word',
                                                            hyphens: 'auto',
                                                            lineHeight: '18px'
                                                        }}>{quantity}</td>
                                                        {canViewCosts && <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase'
                                                        }}>{`$${unit_cost.toFixed(2)}`}</td>}
                                                        <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase'
                                                        }}>
                                                            {quantity}
                                                        </td>
                                                        <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase'
                                                        }}>&nbsp;</td>
                                                        <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase',
                                                            lineHeight: '18px',
                                                            ...cellWrapTight,
                                                        }}>{showLineSvc ? (service_name || '') : ''}</td>
                                                        {canViewCosts && <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase'
                                                        }}>{showLineSvc ? `$${parseFloat(service_cost || 0).toFixed(2)}` : ''}</td>}
                                                        {canViewCosts && <td style={{
                                                            border: '1px solid black',
                                                            padding: '8px',
                                                            textAlign: 'center',
                                                            backgroundColor: 'white',
                                                            color: 'black',
                                                            textTransform: 'uppercase'
                                                        }}>{`$${actual_total_cost.toFixed(2)}`}</td>}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </Box>
                            </Grid>
                        )}

                        {/* {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && <Typography variant='h4' sx={{ mt: 2 }}>{(details?.job_category_name != 'Service only' && details?.job_category_name != 'Time & Material') ? "Additional Services" : 'Services'}</Typography>} */}
                        {/* {(additionalSelectedServices?.length > 0 || invoiceSelectedServices?.length > 0 || cartService?.length > 0) && <Typography variant='h4' sx={{ mt: 2 }}>{(details?.job_category_name != 'Service only') ? "Additional Services" : 'Services'}</Typography>} */}
                        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                                <Box
                                    component="style"
                                    dangerouslySetInnerHTML={{
                                        __html: `
                    .sales-order-table th {
                      background-color: #e6e6e6 !important;
                      color: black !important;
                    }
                  `
                                    }}
                                />
                                {/* PROJECT CONTACT NAME AND PHONE NUMBER */}
                                <table
                                    className="sales-order-table"
                                    style={{
                                        width: '100%',
                                        borderBottom: '1px solid black',
                                        borderTop: '1px solid black',
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        borderCollapse: 'collapse',
                                        textTransform: 'uppercase',
                                        tableLayout: 'fixed'
                                    }}
                                >
                                    <colgroup>
                                       <col style={{ width: '11%' }} />
                                       <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                    </colgroup>
                                    {orderServices && orderServices.length > 0 &&
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        borderBottom: '1px solid black',
                                                        borderLeft: '1px solid black',
                                                        borderRight: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    #
                                                </th>
                                                <th
                                                colSpan={canViewCosts ? 5 : 8}
                                                    style={{
                                                        borderBottom: '1px solid black',
                                                        borderLeft: '1px solid black',
                                                        borderRight: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    SERVICES
                                                </th>
                                                {canViewCosts && <th
                                                colSpan={3}
                                                    style={{
                                                        borderBottom: '1px solid black',
                                                        borderLeft: '1px solid black',
                                                        borderRight: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: '#e6e6e6',
                                                        fontWeight: 'bold',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    TOTAL COST
                                                </th>}
                                            </tr>
                                        </thead>}
                                    <tbody>
                                    {orderServices.map((val,index) => {
                      const serviceName = val.name || val.description || '';
                      const servicePrice = parseFloat(val.price) || 0;
                      return (
                                                <tr key={`print-service-${val.id || index}`}>
                                                    <td style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}>
                                                        {index + 1}
                                                    </td>
                                                    <td colSpan={canViewCosts ? 5 : 8} style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'left',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}>
                                                       {serviceName}
                                                    </td>
                                                    {canViewCosts && <td colSpan={3} style={{
                                                        border: '1px solid black',
                                                        padding: '8px',
                                                        textAlign: 'center',
                                                        backgroundColor: 'white',
                                                        color: 'black',
                                                        textTransform: 'uppercase'
                                                    }}>{`$${servicePrice.toFixed(2)}`}</td>}
                                                </tr>
                                            )
                                        }
                                        )}
                                    </tbody>
                                </table>
                            </Box>
                        </Grid>
                        
                        <Grid item xs={12} sm={12} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                            <Box sx={{ textTransform: 'uppercase', color: 'black', minWidth: 1030 }}>
                                <Box
                                    component="style"
                                    dangerouslySetInnerHTML={{
                                        __html: `
                  .sales-order-table th {
                    background-color: #e6e6e6 !important;
                    color: black !important;
                  }
                `
                                    }}
                                />
                                {/* PROJECT CONTACT NAME AND PHONE NUMBER */}
                                <table
                                    className="sales-order-table"
                                    style={{
                                        width: '100%',
                                        borderBottom: '1px solid black',
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        borderCollapse: 'collapse',
                                        textTransform: 'uppercase',
                                        tableLayout: 'fixed'
                                    }}
                                >
                                    <colgroup>
                                       <col style={{ width: '11%' }} />
                                       <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                    </colgroup>
                                    <tbody>
                                        {/* <tr>
                                            <td style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', whiteSpace: 'normal', wordBreak: 'keep-all', overflowWrap: 'normal', hyphens: 'none', fontSize: '13px', lineHeight: '14px' }}><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px' }}><span style={{ whiteSpace: 'nowrap' }}>Sub</span><span style={{ whiteSpace: 'nowrap' }}>TOTAL</span></div></td>
                                            <td colSpan={3} style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: 'white', color: 'black' }}>
                                                ${details?.sub_total}
                                            </td>
                                        </tr> */}

                                        
                                            {/* <tr>
                                                <td style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                                <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', whiteSpace: 'normal', wordBreak: 'keep-all', overflowWrap: 'normal', hyphens: 'none', fontSize: '13px', lineHeight: '14px' }}><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px' }}><span style={{ whiteSpace: 'nowrap' }}>Sales</span><span style={{ whiteSpace: 'nowrap' }}>Tax</span></div></td>
                                                <td colSpan={3} style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: 'white', color: 'black' }}>
                                                {details?.tax}
                                                </td>
                                            </tr> */}

                                        {canViewCosts && <tr>
                                            <td colSpan={6} style={{ border: '1px solid black', padding: '8px', textAlign: 'left', backgroundColor: 'white', color: 'black', fontSize: '14px', whiteSpace: 'pre-line', minHeight: '140px', verticalAlign: 'top' }}><strong>Vendor Notes / Special Instructions:</strong><br />{formattedNotes || ''}</td>
                                            {/* <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td> */}
                                            <td colSpan={3} style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#ffffff', fontWeight: 'bold', color: 'black', whiteSpace: 'normal', wordBreak: 'keep-all', overflowWrap: 'normal', hyphens: 'none', fontSize: '19px', lineHeight: '14px' }}>
                                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '2px' }}><span style={{ whiteSpace: 'nowrap', fontSize: '28px', fontWeight: 'bold' }}>Total</span><span style={{ whiteSpace: 'nowrap', fontSize: '18px', fontWeight: 'bold' }}>${fUSPrice(details?.grand_total)}</span></div>
                                                {/* <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: '2px' }}><span style={{ whiteSpace: 'nowrap',fontSize: '19px', fontWeight: 'bold' }}>Total</span><span style={{ whiteSpace: 'nowrap',fontSize: '19px', fontWeight: 'bold' }}>{canViewCosts ? `$${fUSPrice(details?.grand_total)}` : '—'}</span></div> */}
                                            </td>
                                        </tr>}

                                    </tbody>
                                </table>
                                <table
                                    className="sales-order-table"
                                    style={{
                                        width: '100%',
                                        borderBottom: '1px solid black',
                                        borderLeft: '1px solid black',
                                        borderRight: '1px solid black',
                                        borderCollapse: 'collapse',
                                        textTransform: 'uppercase',
                                        tableLayout: 'fixed'
                                    }}
                                >
                                    <colgroup>
                                       <col style={{ width: '11%' }} />
                                       <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                        <col style={{ width: '11%' }} />
                                    </colgroup>
                                    <tbody>
                                        {/* <tr>
                                            <td style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', whiteSpace: 'normal', wordBreak: 'keep-all', overflowWrap: 'normal', hyphens: 'none', fontSize: '13px', lineHeight: '14px' }}><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px' }}><span style={{ whiteSpace: 'nowrap' }}>Sub</span><span style={{ whiteSpace: 'nowrap' }}>TOTAL</span></div></td>
                                            <td colSpan={3} style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: 'white', color: 'black' }}>
                                                ${details?.sub_total}
                                            </td>
                                        </tr> */}

                                        
                                            {/* <tr>
                                                <td style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                                <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                                <td style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: '#e6e6e6', fontWeight: 'bold', color: 'black', whiteSpace: 'normal', wordBreak: 'keep-all', overflowWrap: 'normal', hyphens: 'none', fontSize: '13px', lineHeight: '14px' }}><div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '2px' }}><span style={{ whiteSpace: 'nowrap' }}>Sales</span><span style={{ whiteSpace: 'nowrap' }}>Tax</span></div></td>
                                                <td colSpan={3} style={{ border: '1px solid black', padding: '8px', textAlign: 'center', backgroundColor: 'white', color: 'black' }}>
                                                {details?.tax}
                                                </td>
                                            </tr> */}

                                        <tr>
                                            <td colSpan={9} style={{ border: '1px solid black', padding: '8px', textAlign: 'left', backgroundColor: 'white', color: 'black', fontSize: '14px' }}><strong>Purchased by:</strong> {details?.authorized_by || ''}</td>
                                            {/* <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td>
                                            <td colSpan={2} style={{ border: '1px solid black', padding: '8px', backgroundColor: 'white' }}>&nbsp;</td> */}
                                        </tr>

                                    </tbody>
                                </table>
                            </Box>
                        </Grid>
                    </>
            </Grid>
            </Stack>
        </>
    )
})
export default PurchaseOrderInvoicePage;